/**
 * FeedbackHowItWorksPanel — right-rail explainer for the feedback board.
 *
 * States the boundary that matters: this board is for product feedback, while
 * threats/terrorism/scams/fraud/coordinated abuse go to the Council via Report.
 *
 * Pure component — no hooks.
 */
import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import { Icon } from '@/icons';

const Steps = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Step = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
  line-height: 1.4;
`;

const IconWrap = styled.span`
  flex-shrink: 0;
  margin-top: 2px;
  color: ${({ theme }) => theme.color.textMuted};
`;

const Divider = styled.hr`
  margin: 14px 0 10px;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.color.glassBorder};
`;

const Note = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
  line-height: 1.5;
`;

export function FeedbackHowItWorksPanel() {
  return (
    <Panel>
      <SectionLabel as="h2">How this works</SectionLabel>
      <Steps>
        <Step>
          <IconWrap>
            <Icon name="plus" size={14} />
          </IconWrap>
          Post an idea, a bug, or something that felt wrong.
        </Step>
        <Step>
          <IconWrap>
            <Icon name="trending-up" size={14} />
          </IconWrap>
          Upvote what matters, and the most-wanted rises to the top.
        </Step>
        <Step>
          <IconWrap>
            <Icon name="check" size={14} />
          </IconWrap>
          We update the status as it moves from Open to Shipped.
        </Step>
      </Steps>

      <Divider />

      <Note>
        This board is for product feedback. Threats, terrorism, scams, fraud or coordinated abuse
        belong in Report on the post itself. Those go to the Council.
      </Note>
    </Panel>
  );
}
